module.exports = __webpack_public_path__ + "static/water_nubian5-16f817e122d50fd4b865bf4d11377f9e.jpg";